import { PaymentStatus } from '@repo/graphql-types'
import type { PaymentRecoveryModel, StatusDialogsResult } from './types'

interface PaymentStatusRecoveryInput {
  paymentStatus?: PaymentStatus | null
  message?: string | null
  error?: { message: string; type: string } | null
  userBanned?: boolean | null
}

function getRecoveryUrl(url?: string | null): string | null {
  return url ? url : null
}

export function getPaymentRecoveryModelFromStatusDialogsResult(
  result: StatusDialogsResult | null,
): PaymentRecoveryModel | null {
  if (!result) {
    return null
  }

  return getPaymentRecoveryModelFromPaymentStatus({
    paymentStatus: result.paymentsStatus,
    message: result.message,
    error: result.error,
    userBanned: result.userBanned,
  })
}

export function getPaymentRecoveryModelFromPaymentStatus({
  paymentStatus,
  message,
  error,
  userBanned,
}: PaymentStatusRecoveryInput): PaymentRecoveryModel | null {
  if (userBanned) {
    return { kind: 'userBanned' }
  }

  if (paymentStatus === PaymentStatus.Succeeded) {
    return null
  }

  if (!paymentStatus) {
    return error ? { kind: 'genericError', message: error.message } : null
  }

  const recoveryUrl = getRecoveryUrl(message)

  if (paymentStatus === PaymentStatus.RequiresAction) {
    return recoveryUrl ? { kind: 'requiresAction', recoveryUrl } : { kind: 'genericError' }
  }

  if (paymentStatus === PaymentStatus.Failed) {
    return recoveryUrl
      ? { kind: 'failedWithRecoveryUrl', recoveryUrl }
      : { kind: 'failedPaymentMethod' }
  }

  if (paymentStatus === PaymentStatus.Processing) {
    return recoveryUrl ? { kind: 'processing', recoveryUrl } : { kind: 'processing' }
  }

  return error ? { kind: 'genericError', message: error.message } : null
}
